/**
 * AddPatientModal.js
 * Modal para agregar un paciente externo (sin LemmonTag)
 */
import React, { useState } from "react";
import { crearPacienteExterno } from "../../services/api";

const ESPECIES = [
  { value: "perro", label: "Perro" },
  { value: "gato", label: "Gato" },
  { value: "ave", label: "Ave" },
  { value: "otro", label: "Otro" },
];

export default function AddPatientModal({ vetId, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    nombre: "",
    especie: "perro",
    raza: "",
    nombreDueno: "",
    telefonoDueno: "",
    emailDueno: "",
    notas: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const result = await crearPacienteExterno(vetId, formData);

    if (result.error) {
      setError(result.error);
      setLoading(false);
      return;
    }

    setLoading(false);
    onSuccess(result.data);
  };

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        className="card shadow"
        style={{
          width: "100%",
          maxWidth: "500px",
          maxHeight: "calc(100vh - 40px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="card-header d-flex justify-content-between align-items-center" style={{ flexShrink: 0 }}>
          <h5 className="mb-0">Agregar Paciente Externo</h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            disabled={loading}
          />
        </div>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", overflow: "hidden", flex: 1 }}>
          <div
            className="card-body"
            style={{ overflowY: "auto", flex: 1 }}
          >
            {error && (
              <div className="alert alert-danger py-2">{error}</div>
            )}

            <p className="text-muted small mb-3">
              Los pacientes externos son aquellos que no tienen un LemmonTag registrado.
            </p>

            {/* Nombre */}
            <div className="mb-3">
              <label className="form-label">
                Nombre del paciente <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                required
                placeholder="Ej: Firulais"
              />
            </div>

            {/* Especie */}
            <div className="mb-3">
              <label className="form-label">
                Especie <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="especie"
                value={formData.especie}
                onChange={handleChange}
                required
              >
                {ESPECIES.map((esp) => (
                  <option key={esp.value} value={esp.value}>
                    {esp.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Raza */}
            <div className="mb-3">
              <label className="form-label">Raza</label>
              <input
                type="text"
                className="form-control"
                name="raza"
                value={formData.raza}
                onChange={handleChange}
                placeholder="Ej: Labrador"
              />
            </div>

            <hr />
            <h6 className="text-muted">Datos del propietario</h6>

            {/* Nombre del dueno */}
            <div className="mb-3">
              <label className="form-label">
                Nombre del propietario <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="nombreDueno"
                value={formData.nombreDueno}
                onChange={handleChange}
                required
                placeholder="Ej: Juan Perez"
              />
            </div>

            {/* Telefono del dueno */}
            <div className="mb-3">
              <label className="form-label">
                Telefono <span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                name="telefonoDueno"
                value={formData.telefonoDueno}
                onChange={handleChange}
                required
                placeholder="Ej: 5512345678"
              />
            </div>

            {/* Email del dueno */}
            <div className="mb-3">
              <label className="form-label">Correo electronico</label>
              <input
                type="email"
                className="form-control"
                name="emailDueno"
                value={formData.emailDueno}
                onChange={handleChange}
                placeholder="Ej: juan@email.com"
              />
            </div>

            {/* Notas */}
            <div className="mb-3">
              <label className="form-label">Notas</label>
              <textarea
                className="form-control"
                name="notas"
                value={formData.notas}
                onChange={handleChange}
                rows={2}
                placeholder="Ej: Alergico a penicilina"
              />
            </div>
          </div>

          <div className="card-footer d-flex justify-content-end gap-2" style={{ flexShrink: 0, borderTop: "1px solid #dee2e6" }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
